<template>
    <div class="flex justify-center items-center container c-pad pb-16">
        <!-- π ----
        // :: PREV
        // : ---------------------------------- -->
        <button
            class="relative flex justify-center items-center w-16 h-16 rounded-full text-white text-lg leading-none select-none mx-2 transition-colors duration-300 ease-in-out-quad group"
        >
            <div
                class="absolute inset-0 w-full h-full border border-gray-800 rounded-full lg:opacity-0 lg:group-hover:opacity-100 transition-all duration-500 ease-in-out-circ transform lg:scale-100 lg:group-hover:scale-75"
            ></div>
            <div class="relative">
                <div
                    class="group-hover:opacity-0 transition-all duration-500 ease-in-out-circ transform translate-y-0 group-hover:-translate-y-full"
                >
                    &larr;
                </div>
                <div
                    class="absolute inset-0 opacity-0 group-hover:opacity-100 transition-all duration-500 ease-in-out-circ transform translate-y-full group-hover:translate-y-0"
                >
                    &larr;
                </div>
            </div>
        </button>

        <!-- π ----
        // :: NUMBERS
        // : ---------------------------------- -->
        <button
            class="hidden md:flex justify-center items-center w-12 h-12 bg-ocean-600 border border-ocean-400 rounded-full text-white font-mono text-sm leading-none select-none mx-2 transition-colors duration-300 ease-in-out-quad"
        >
            <span class="">1</span>
        </button>

        <button
            class="hidden md:flex justify-center items-center w-12 h-12 bg-ocean-700 border border-transparent hover:border-ocean-500 rounded-full text-white font-mono text-sm leading-none select-none mx-2 transition-all duration-500 ease-in-out-circ"
        >
            <span class="">2</span>
        </button>

        <button
            class="hidden md:flex justify-center items-center w-12 h-12 bg-ocean-700 border border-transparent hover:border-ocean-500 rounded-full text-white font-mono text-sm leading-none select-none mx-2 transition-all duration-500 ease-in-out-circ"
        >
            <span class="">3</span>
        </button>

        <!-- π ----
        // :: NEXT
        // : ---------------------------------- -->
        <button
            class="relative flex justify-center items-center w-16 h-16 rounded-full text-white text-lg leading-none select-none mx-2 transition-colors duration-300 ease-in-out-quad group"
        >
            <div
                class="absolute inset-0 w-full h-full border border-gray-800 rounded-full lg:opacity-0 lg:group-hover:opacity-100 transition-all duration-500 ease-in-out-circ transform lg:scale-100 lg:group-hover:scale-75"
            ></div>
            <div class="relative">
                <div
                    class="group-hover:opacity-0 transition-all duration-500 ease-in-out-circ transform translate-y-0 group-hover:-translate-y-full"
                >
                    &rarr;
                </div>
                <div
                    class="absolute inset-0 opacity-0 group-hover:opacity-100 transition-all duration-500 ease-in-out-circ transform translate-y-full group-hover:translate-y-0"
                >
                    &rarr;
                </div>
            </div>
        </button>
    </div>
</template>

<script>
export default {};
</script>
